import { Component } from '@angular/core';
import { GuestHeader } from '@app/shared/components/header/guest-header/guest-header';
import { RouterOutlet } from '@angular/router';
import { GuestFooter } from '@app/shared/components/footer/guest-footer/guest-footer';
import { FeedbackWidget } from '@shared/components/feedback-widget/feedback-widget';

@Component({
  selector: 'app-guest-layout',
  imports: [GuestHeader, RouterOutlet, GuestFooter, FeedbackWidget],
  templateUrl: './guest-layout.html',
  styleUrl: './guest-layout.scss'
})
export class GuestLayout {

}
